<template>
    <TableWrapper tableContainerId="positions_table_container">

        <template v-slot:tableHead>
            <TablePositionsHead @onSort="handleSortData" />
        </template>

        <template v-slot:tableBody>
            <TablePositionsRow v-for="(position, index) in positionsList"
                :index="index"
                :key="position.id"
                :position="position"
                @positionDeleted="showDeletedNotif"
                @openSendReport="openSendReportModal"
                @openCampaignLink="openCampaignLinkModal"
                @openAddEvals="openAddEvalModal" />
        </template>

        <template v-slot:tableHelpers>
            <AddEvalsModal :opened="AddEvalModalOpened" @closeAddEvals="closeAddEvalsModal" @addEvalSuccess="addEvalSuccessNotif = true" />

            <SendReportModal :opened="SendReportModalOpened" @closeSendReport="closeSendReportModal" @sendReportSuccess="addSendReportNotif = true" />
            <!-- <CampaignLinkModal :opened="CampaignLinkOpened" @closeCampaignLink="closeCampaignLinkModal" /> -->

            <transition name="notif-slide-up">
                <alert v-if="addSendReportNotif" context="success" @close="addSendReportNotif=false">{{ $t('modules.positions.index.positionsList.alertSendReport') }}</alert>
            </transition>

            <transition name="notif-slide-up">
                <alert v-if="addEvalSuccessNotif" context="success" @close="addEvalSuccessNotif=false">{{ $t('modules.positions.index.positionsList.alertaddEvals') }}</alert>
            </transition>

            <transition name="notif-slide-up">
                <alert v-if="showPositionDeletedNotif" context="success" @close="showPositionDeletedNotif=false">{{ $t('modules.positions.index.positionsList.alertDeletePosition') }}</alert>
            </transition>
        </template>

    </TableWrapper>

</template>

<script>
import AddEvalsModal from './addEvalsModal'
import SendReportModal from './sendReportModal'
import CampaignLinkModal from './campaignLinkModal'

import TablePositionsHead from './tablePositionsHead'
import TablePositionsRow from './tablePositionsRow'
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'

export default {
    name: 'TablePositions',
    props: ['searchQuery'],
    components: {
        AddEvalsModal,
        SendReportModal,
        CampaignLinkModal,
        TablePositionsHead,
        TablePositionsRow
    },
    data(){
        return {
            SendReportModalOpened: false,
            addSendReportNotif: false,
            AddEvalModalOpened: false,
            CampaignLinkOpened: false,
            addEvalSuccessNotif: false,
            showPositionDeletedNotif: false,
            sortableData: {name: 'created_at', type: 'desc'}
        }
    },
    computed: {
        positionsList(){
            return this.$store.state.PositionStore.positionsList
        }
    },
    methods: {
        openSendReportModal(position){
            this.$store.commit('PositionStore/initEdit', position)
            this.SendReportModalOpened = true
        },
        closeSendReportModal(position){
            this.SendReportModalOpened = false
        },
        openCampaignLinkModal(position){
            this.$store.commit('PositionStore/initEdit', position)
            this.CampaignLinkOpened = true
        },
        closeCampaignLinkModal(position){
            this.CampaignLinkOpened = false
        },
        openAddEvalModal(position){
            if(userCanAccess('features', 'create_sight_group')){
                this.$store.commit('PositionStore/initEdit', position)
                this.AddEvalModalOpened = true
            }else{
                this.$router.push('/unautorized');
            }
        },
        closeAddEvalsModal(position){
            this.AddEvalModalOpened = false
        },
        showDeletedNotif(){
            this.addEvalSuccessNotif = true
        },
        handleSortData(sortName, sortType){
            const data = {
                sort_column: sortName,
                sort_type: sortType
            }
            this.$store.dispatch('PositionStore/indexPositions', data)
        }
    }
}
</script>
